var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "log-container" },
    [
      _c("div", { staticClass: "log-title" }, [
        _c("span", { staticStyle: { color: "black", "font-weight": "bold" } }, [
          _vm._v(_vm._s(_vm.$t("lang_flow_log_process_opinion"))),
        ]),
        _vm._processEnd
          ? _c("span", { staticClass: "process-end" }, [
              _vm._v("(" + _vm._s(_vm.$t("lang_ended")) + ")"),
            ])
          : _vm._e(),
      ]),
      _c(
        "el-timeline",
        { staticClass: "log-content" },
        _vm._l(_vm.logs, function (nodeItem, index) {
          return _c(
            "el-timeline-item",
            {
              key: nodeItem.nodeId,
              staticClass: "log-item-wrapper",
              attrs: {
                size: "large",
                color: nodeItem.color,
                id: nodeItem.nodeId,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "log-item-title",
                  style: {
                    color: nodeItem.color,
                    fontWeight: nodeItem.fontWeight,
                  },
                },
                [_vm._v(" " + _vm._s(nodeItem.displayNodeName) + " ")]
              ),
              nodeItem.runtimeId != _vm._currentTask.runtimeId
                ? _c(
                    "div",
                    {
                      staticClass: "log-item-tip",
                      on: {
                        click: function ($event) {
                          return _vm.openHistoryTask(nodeItem)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(nodeItem.nodeTip) + " ")]
                  )
                : _vm._e(),
              _vm._l(nodeItem.taskHistories, function (logItem, i) {
                return _c(
                  "div",
                  {
                    key: logItem.id,
                    staticClass: "log-item-content",
                    style: {
                      color: nodeItem.fontColor,
                      fontWeight: nodeItem.fontWeight,
                      borderColor: nodeItem.color,
                    },
                  },
                  [
                    logItem.completed
                      ? [
                          _c("div", { staticClass: "log-item-row" }, [
                            _c("div", { staticClass: "log-item-row-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("lang_flow_log_handler")) + "："
                              ),
                            ]),
                            _c("div", { staticClass: "log-item-row-value" }, [
                              _vm._v(
                                " " + _vm._s(logItem.completedUserName) + " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "log-item-row" }, [
                            _c("div", { staticClass: "log-item-row-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("lang_flow_log_process_result")) +
                                  "："
                              ),
                            ]),
                            _c("div", { staticClass: "log-item-row-value" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "log-item-row-value-type",
                                  style: {
                                    backgroundColor: nodeItem.color,
                                    color: "#fff",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getSubmitTypeName(logItem)) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          logItem.userRemark
                            ? _c("div", { staticClass: "log-item-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "log-item-row-label" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "lang_flow_log_handling_comments"
                                        )
                                      ) + "："
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "log-item-row-value" },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 15 } },
                                          [
                                            logItem.showInput
                                              ? [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          logItem.userRemark,
                                                        expression:
                                                          "logItem.userRemark",
                                                      },
                                                    ],
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    attrs: { type: "text" },
                                                    domProps: {
                                                      value: logItem.userRemark,
                                                    },
                                                    on: {
                                                      keyup: function ($event) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          _vm._k(
                                                            $event.keyCode,
                                                            "enter",
                                                            13,
                                                            $event.key,
                                                            "Enter"
                                                          )
                                                        ) {
                                                          return null
                                                        }
                                                        return _vm.save(
                                                          logItem.id,
                                                          logItem.userRemark
                                                        )
                                                      },
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          logItem,
                                                          "userRemark",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        logItem.userRemark
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                        _vm.allowUpdate
                                          ? _c(
                                              "el-col",
                                              { attrs: { span: 9 } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "changeRemark",
                                                    staticStyle: {
                                                      float: "right",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showInput(
                                                          index,
                                                          i
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("修改意见")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          logItem.userRemarkFiles &&
                          logItem.userRemarkFiles.length
                            ? _c("div", { staticClass: "log-item-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "log-item-row-label" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("lang_flow_log_appendix")) +
                                        "："
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    ref: "eleUpload",
                                    refInFor: true,
                                    staticClass: "log-item-row-value",
                                  },
                                  [
                                    _c("ele-upload", {
                                      staticClass: "upload-demo",
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: "" },
                                      model: {
                                        value: logItem.userRemarkFiles,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            logItem,
                                            "userRemarkFiles",
                                            $$v
                                          )
                                        },
                                        expression: "logItem.userRemarkFiles",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "log-item-row" }, [
                            _c("div", { staticClass: "log-item-row-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("lang_flow_log_processing_date")
                                ) + "："
                              ),
                            ]),
                            _c("div", { staticClass: "log-item-row-value" }, [
                              _vm._v(
                                _vm._s(_vm.getDatetime(logItem.completedDate))
                              ),
                            ]),
                          ]),
                        ]
                      : [
                          _c("div", { staticClass: "log-item-row" }, [
                            _c("div", { staticClass: "log-item-row-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("lang_flow_log_assignee")) + "："
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "log-item-row-value" },
                              _vm._l(
                                logItem.performers,
                                function (userId, userIndex) {
                                  return _c("span", { key: userId }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          logItem.performersNames[userIndex]
                                        ) +
                                        " "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                          _c("div", { staticClass: "log-item-row" }, [
                            _c("div", { staticClass: "log-item-row-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("lang_flow_log_acceptance_result")
                                ) + "："
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "log-item-row-value-type",
                                style: {
                                  backgroundColor:
                                    _vm.getSubmitTypeName(logItem) == "到达"
                                      ? "#dd8877"
                                      : nodeItem.color,
                                  color: "#fff",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.getSubmitTypeName(logItem)) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "log-item-row" }, [
                            _c("div", { staticClass: "log-item-row-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("lang_flow_log_arrival_date")) +
                                  "："
                              ),
                            ]),
                            _c("div", { staticClass: "log-item-row-value" }, [
                              _vm._v(
                                _vm._s(_vm.getDatetime(logItem.createDate))
                              ),
                            ]),
                          ]),
                        ],
                    false
                      ? _c(
                          "div",
                          {
                            staticClass: "log-type",
                            style: {
                              backgroundColor: nodeItem.color,
                              color: "#fff",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.getSubmitTypeName(logItem)) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          )
        }),
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "65%",
            top: "20px",
            "append-to-body": "",
            "close-on-click-modal": true,
            visible: _vm.showImDlg,
          },
          on: {
            close: function ($event) {
              _vm.showImDlg = false
            },
          },
        },
        [
          _vm.showImDlg
            ? _c("iframe", {
                attrs: {
                  src: _vm.imUrl,
                  frameborder: "0",
                  width: "100%",
                  height: "600px",
                },
              })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }